
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const orderApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listOrders: builder.query ({
      query: (params) => `v2/order/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Order"]
    }),
    getOrder: builder.query ({
      query: (order_id) => `v2/order/${order_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Order"]
    }),
    getOrderLineitems: builder.query ({
      query: (order_id) => `v2/lineitem/?order=${order_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["LineItem"]
    }),
    getOrderRemakes: builder.query ({
      query: (order_id) => `v2/remake/?order=${order_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Remake"]
    }),
    getOrderActions: builder.query ({
      query: (order_id) => `v2/action/?order=${order_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Action"]
    }),
    getOrderNotes: builder.query ({
      query: (order_id) => `v2/note/?order=${order_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Note"]
    }),
    getOrderShipping_labels: builder.query ({
      query: (order_id) => `v2/shippinglabel/?order=${order_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["ShippingLabel"]
    }),
    getOrderTracking_info: builder.query ({
      query: (order_id) => `v2/trackinginfo/?order=${order_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["TrackingInfo"]
    }),
    getOrderRefunds: builder.query ({
      query: (order_id) => `v2/refund/?order=${order_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Refund"]
    }),
    getOrderPhotos: builder.query ({
      query: (order_id) => `v2/photo/?order=${order_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Photo"]
    }),
    updateOrder: builder.mutation ({
      query: ({order_id, data}) => ({
        url: `v2/order/${order_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Order"]
    }),
    deleteOrder: builder.mutation ({
      query: (order_id) => ({
        url: `v2/order/${order_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Order"]
    }),
    createOrder: builder.mutation ({
      query: (data) => ({
        url: `v2/order/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Order"]
    }),
  })
})


export const {
  useListOrdersQuery,
  useLazyListOrdersQuery,
  useGetOrderQuery,
  useLazyGetOrderQuery,
  useGetOrderLineitemsQuery,
  useGetOrderRemakesQuery,
  useGetOrderActionsQuery,
  useGetOrderNotesQuery,
  useGetOrderShipping_labelsQuery,
  useGetOrderTracking_infoQuery,
  useGetOrderRefundsQuery,
  useGetOrderPhotosQuery,
  useUpdateOrderMutation,
  useDeleteOrderMutation,
  useCreateOrderMutation
} = orderApi
